import {
  ADMIN_USER_ROLE,
  MANAGER_USER_ROLE,
  USER_STATUS_CODE_ACTIVE,
  USER_STATUS_CODE_BLOCKED,
  USER_STATUS_CODE_INVITED,
} from '../../../../constants/user'

const FULL_STAFF_PERMISSIONS = {
  can_block_user: true,
  can_create_request: true,
  can_delete: true,
  can_edit: true,
  can_edit_external_id: true,
  can_edit_files: true,
  can_edit_functional_role: true,
  can_edit_role: true,
  can_edit_sso_id: true,
  can_restore: true,
  can_send_invite: true,
  can_start_new_chat: true,
  can_unblock_user: true,
}

const BASE_STAFF_MOCK = {
  avatar: null,
  avatar_color: '#9B5BF1',
  companyPostName: 'Hausverwalter Mitarbeiter',
  externalId: 'EL18.PER.256038',
  fullname: 'Monica Becker',
  functionalRole: { id: 1, name: 'Technical Property Manager' },
  id: 9999998,
  invitedAt: '2023-01-10T09:00:00Z',
  is_system: false,
  isArchived: false,
  isStaff: true,
  lastLoginAt: '2023-01-22T16:00:00Z',
  permissions: FULL_STAFF_PERMISSIONS,
  registeredAt: '2023-01-22T15:00:00Z',
  role: ADMIN_USER_ROLE,
  ssoId: '5618OLK2541',
}

export const PROFILE_HEADER_USER_STAFF_VARIANTS = [
  {
    label: 'Admin header — Online, full data (SSO id + functional role)',
    staffData: {
      ...BASE_STAFF_MOCK,
      status: USER_STATUS_CODE_ACTIVE,
    },
  },
  {
    label: 'Admin header — without SSO id and functional role',
    staffData: {
      ...BASE_STAFF_MOCK,
      functionalRole: undefined,
      ssoId: undefined,
      status: USER_STATUS_CODE_ACTIVE,
    },
  },
  {
    label: 'Manager header — Invited (last invitation date)',
    staffData: {
      ...BASE_STAFF_MOCK,
      fullname: 'John Sachs',
      role: MANAGER_USER_ROLE,
      status: USER_STATUS_CODE_INVITED,
    },
  },
  {
    label: 'Manager header — low-privilege viewer (Role + Job position only)',
    staffData: {
      avatar: null,
      avatar_color: '#DD9A80',
      companyPostName: 'Hausverwalter Mitarbeiter',
      fullname: 'John Sachs',
      id: 9999997,
      is_system: false,
      isArchived: false,
      isStaff: true,
      permissions: {},
      role: MANAGER_USER_ROLE,
      status: USER_STATUS_CODE_ACTIVE,
    },
  },
  {
    label: 'Admin header — Blocked',
    staffData: {
      ...BASE_STAFF_MOCK,
      status: USER_STATUS_CODE_BLOCKED,
    },
  },
  {
    label: 'Admin header — archived',
    staffData: {
      ...BASE_STAFF_MOCK,
      isArchived: true,
      permissions: { ...FULL_STAFF_PERMISSIONS, can_edit_role: false },
      status: USER_STATUS_CODE_ACTIVE,
    },
  },
]
